
import React from 'react';
import { useGame } from '../../contexts/GameContext';
import DecisionModal from '../DecisionModal';
import SpecialEventModal from '../events/SpecialEventModal';
import CareerPathSelection from './CareerPathSelection';

interface CareerModalsProps {
  showDecisionModal: boolean;
  showSpecialEventModal: boolean;
  showPathSelection: boolean;
  canSelectPath: boolean;
  onCloseDecision: () => void;
  onCloseSpecialEvent: () => void;
  onClosePathSelection: () => void;
}

const CareerModals: React.FC<CareerModalsProps> = ({
  showDecisionModal,
  showSpecialEventModal,
  showPathSelection,
  canSelectPath,
  onCloseDecision,
  onCloseSpecialEvent,
  onClosePathSelection
}) => {
  const { currentChallenge, currentSpecialEvent } = useGame();
  
  return (
    <>
      {showDecisionModal && currentChallenge && (
        <DecisionModal 
          challenge={currentChallenge} 
          onClose={onCloseDecision}
        />
      )}
      
      {showSpecialEventModal && currentSpecialEvent && (
        <SpecialEventModal
          event={currentSpecialEvent}
          onClose={onCloseSpecialEvent}
        />
      )}
      
      {showPathSelection && canSelectPath && (
        <CareerPathSelection
          open={showPathSelection}
          onClose={onClosePathSelection}
        />
      )}
    </>
  );
};

export default CareerModals;
